module.exports = {
        srcSet: __webpack_public_path__ + "amenities_in_post-865-4355d8398a30f50a.digested.jpg"+" 865w",
        images: [{path: __webpack_public_path__ + "amenities_in_post-865-4355d8398a30f50a.digested.jpg",width: 865,height: 386}],
        src: __webpack_public_path__ + "amenities_in_post-865-4355d8398a30f50a.digested.jpg",
        toString: function(){return __webpack_public_path__ + "amenities_in_post-865-4355d8398a30f50a.digested.jpg"},
        
        width: 865,
        height: 386
      }